import { getCityState } from '../utils';

export const selectCurrent = (state) => getCityState(state).current;
export const selectCurrentId = (state) => getCityState(state).current?.id;
export const selectCurrentName = (state) => getCityState(state).current?.name;
